import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import ModalDeleteProject from "components/ModalDeleteProject/ModalDeleteProject";
import { projectScheduleDeleteAdminManageDjango } from "hooks/useProjectSheduleDeleteDjango/useProjectSheduleDeleteDjango";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

interface ButtonIconDeleteProjectProps {
  projectId: string;
  tenantKey: string;
}

/**
 * Renders a permissioned button with a tooltip to delete a project.
 * Opens a modal to delete the project when clicked.
 * Routes to the project's organization page upon successful deletion.
 * Consumes the {@link useModalContext} hook to manage modal state.
 */
export const ButtonIconDeleteProject = ({
  projectId,
  tenantKey,
}: ButtonIconDeleteProjectProps) => {
  const { openModal, closeModal } = useModalContext();

  const orgRoute = useRouteMapContext((s) => s.routeMap.ORGANIZATION);

  const goToOrganization = () => {
    orgRoute
      .dynamicPath({
        tenantKey,
      })
      .navigateTo();
  };

  return (
    <ButtonIconPermissioned
      requiredPermission="grant_access"
      defaultTooltip="Delete project"
      iconType="trash"
      aria-label="Delete this project"
      onClick={() => {
        openModal(
          <ModalDeleteProject
            deleteProject={projectScheduleDeleteAdminManageDjango}
            projectId={projectId}
            onSuccess={goToOrganization}
            onClose={closeModal}
          />,
        );
      }}
      color="danger"
      data-test-subj="delete-project-button"
    />
  );
};
